<mat-card appearance="outlined">
  <mat-card-header>
    <mat-card-title>{{ dialogData.title }}</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <form #form="ngForm">
      <mat-form-field appearance="outline">
        <mat-label>Field Name</mat-label>
        <input
          [ngModel]="dialogData.fieldName"
          [disabled]="dialogData.mandatory"
          (ngModelChange)="onFieldNameChange($event)"
          matInput
          type="text"
          name="fieldName"
          maxLength="50"
          required
          />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Value</mat-label>
          <input
            [ngModel]="dialogData.value"
            [attr.maxlength]="fieldValueLenght"
            (ngModelChange)="onValueChange($event)"
            matInput
            type="text"
            name="value"
            required
            />
          </mat-form-field>
        </form>
        @if (form?.controls['fieldName']?.invalid && dialogData.fieldName) {
          <div
            class="alert"
            >
            Another field already exists with this name, please insert a different
            name
          </div>
        }
      </mat-card-content>
      <mat-card-actions align="end">
        <button id="cancel-additionalInfo" (click)="cancel()" mat-button>
          CANCEL
        </button>
        <button
          id="save-additionalInfo"
          [disabled]="form?.invalid"
          (click)="save()"
          mat-button
          color="primary"
          >
          {{ dialogData.actionButtonText }}
        </button>
      </mat-card-actions>
    </mat-card>
